import messages from '../../locale/jsonMessages';

const isEmpty = (value) => value === undefined ||
  value === null || value?.toString().trim() === '';

const exceedsLimit = (value, limit) =>
  typeof value === 'string' && value?.toString().trim()?.length > limit;

const validate = (values, props) => {
  const errors = {};
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  if (values?.dynamicServicePlans) {
    let dynamicServicePlansError = [];
    const selectedLanguages = values.dynamicServicePlans.map(plan => plan?.language?.toString().trim());

    values.dynamicServicePlans.map((item, index) => {
      const dynamicNameError = {};

      const isLanguageInactive = item?.language && activeLanguageCodes.length > 0
        && !activeLanguageCodes.includes(item.language);

      const isDuplicateLanguage = item?.language &&
        selectedLanguages.indexOf(item.language.toString().trim()) !== index;

      if (!item?.language || item?.language.toString().trim() === '' || isLanguageInactive) {
        dynamicNameError.language = messages.required;
        dynamicServicePlansError[index] = dynamicNameError;
      } else if (isDuplicateLanguage) {
        dynamicNameError.language = messages.languageAlreadySelected;
        dynamicServicePlansError[index] = dynamicNameError;
      }

      if (!item?.planName || item?.planName.toString().trim() === '') {
        dynamicNameError.planName = messages.required;
        dynamicServicePlansError[index] = dynamicNameError;
      } else if (exceedsLimit(item?.planName, 50)) {
        dynamicNameError.planName = messages.codeRestriction;
        dynamicServicePlansError[index] = dynamicNameError;
      }

      if (!item?.description || item?.description.toString().trim() === '') {
        dynamicNameError.description = messages.required;
        dynamicServicePlansError[index] = dynamicNameError;
      } else if (exceedsLimit(item?.description, 5000)) {
        dynamicNameError.description = messages.descriptionRestriction;
        dynamicServicePlansError[index] = dynamicNameError;
      }
    });

    if (dynamicServicePlansError?.length > 0) errors.dynamicServicePlans = dynamicServicePlansError;
  }

  if (isEmpty(values?.duration)) {
    errors.duration = messages.required;
  }

  if (isEmpty(values?.currency)) {
    errors.currency = messages.required;
  }

  if (isEmpty(values?.price)) {
    errors.price = messages.required;
  } else if (values?.price) {
    if (isNaN(values?.price) || (!/^[0-9\.]+$/.test(values?.price)) || (parseFloat(values?.price, 10) < 1)) {
      errors.price = messages.invalid;
    }
  } else if (exceedsLimit(values?.price, 15)) {
    errors.price = messages.exceedLimit;
  }

  if (isEmpty(values?.serviceFee)) {
    errors.serviceFee = messages.required;
  } else if (isNaN(values?.serviceFee) || (!/^[0-9\.]+$/.test(values?.serviceFee))) {
    errors.serviceFee = messages.invalid;
  } else if (values.serviceFee && (parseInt(values.serviceFee) < 0 || parseInt(values.serviceFee) > 99)) {
    errors.serviceFee = messages.choosePercentageValue;
  }

  return errors;
};

export default validate;